import { createSlice } from '@reduxjs/toolkit';

export const userConfigurationsSlice = createSlice({

    name: 'userConfigurations',

    initialState: {
        configurations: [],
        tmpDuration: null,
        selectedVehicleID: null,
        selectedCustomer: {},
        selectedVehicleType: null,
        selectedProduct: {}
    },

    reducers: {

        clearAllUserConfigurations(state, action) {
            state.configurations = [];
        },

        clearUserConfiguration(state, action) {
            const {
                EIM
            } = action.payload;

            const index = state.configurations.findIndex( c => c.EIM === EIM );
            if(index !== -1) {
                state.configurations.splice(index,1);
            }
        },

        setSelectedVehicleID(state, action) {
            state.selectedVehicleID = action.payload;
        },

        setSelectedCustomer(state, action) {
            const {
                EIM,
                customer,
                vehicleType,
                appData,
                rates
            } = action.payload;

            state.selectedCustomer[EIM] = customer;
            const userConfigurationIndex = state.configurations.findIndex( c => c.EIM === EIM && c.selectedProduct && c.vehicleType === vehicleType && c.customer === customer);
            if(userConfigurationIndex >= 0) {
                const selectedProduct = state.configurations[userConfigurationIndex];
                state.selectedProduct[EIM] = selectedProduct.productTypeCode;
                saveProductSelectionUserConfiguration({
                    EIM: EIM,
                    fieldValue: selectedProduct.productTypeCode,
                    vehicleType: vehicleType,
                    appData: appData,
                    rates: rates
                });
            }

        },

        setSelectedProduct(state, action) {
            state.selectedProduct[action.payload.EIM] = action.payload.value;
        },

        initializeStorage(state, action) {
            const {
                EIM,
                customer,
                vehicleType,
                fieldValue
            } = action.payload;
            fieldValue.forEach( (product) => {
                const storeElement = {
                    EIM: EIM,
                    vehicleType: vehicleType,
                    productTypeCode: product.productTypeCode,
                    selectedProduct: product.defaultFinancialProduct,
                    rateID: product.rateID,
                    customer: customer
                }

                const userConfigurationIndex = state.configurations.findIndex( c => c.EIM === EIM && c.productTypeCode === product.productTypeCode && c.vehicleType === product.vehicleType && c.customer === customer);
                if(userConfigurationIndex === -1 && state.configurations.length === fieldValue.length) {
                    const index = state.configurations.findIndex(c => c.EIM === EIM && c.customer === customer);
                    if (index !== -1) {
                        state.configurations.splice(index, 1);
                    }
                }
                if(userConfigurationIndex === -1) {
                    state.configurations.push(storeElement);
                }
            })
        },

        saveProductSelectionUserConfiguration(state, action) {
            const {
                EIM,
                fieldValue,
                vehicleType
            } = action.payload;
            state.configurations.forEach(c => {
                if(c.EIM === EIM && c.productTypeCode === fieldValue && c.customer === state.selectedCustomer[EIM] && c.vehicleType === vehicleType) c.selectedProduct = true;
                else if(c.EIM === EIM && c.productTypeCode !== fieldValue && c.customer === state.selectedCustomer[EIM] && c.vehicleType === vehicleType) c.selectedProduct = false;
            });
        }

    },
});

export const getUserConfigurations = state => state.userConfigurations.configurations;
export const getSelectedCustomer = state => state.userConfigurations.selectedCustomer[state.userConfigurations.selectedVehicleID];
export const getAllSelectedCustomer = state => state.userConfigurations.selectedCustomer;

export const {
    initializeStorage,
    saveProductSelectionUserConfiguration,
    clearUserConfiguration,
    clearAllUserConfigurations,
    setSelectedVehicleID,
    setSelectedCustomer,
    setSelectedProduct,
} = userConfigurationsSlice.actions;

export default userConfigurationsSlice.reducer;



